export default "__VITE_PUBLIC_ASSET__384e0383__"